import React, { useState } from 'react';
import { Modal, Box, Typography, Button, Card, Switch, FormControlLabel } from '@mui/material';
import logomp from "../statics/img/medio_pago/mercado-pago-logo-0.png"
import { subscribeToPlan, getCurrentUser, createRecurringPayment, createOneTimePayment } from '../services/subcriptions';

interface SubscriptionModalProps {
  open: boolean;
  onClose: () => void;
  planName: string;
  planId: number | null;
  planBillingCycle: string;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const SubscriptionModal: React.FC<SubscriptionModalProps> = ({ open, onClose, planName, planId, planBillingCycle }) => {
  const [renewSubscription, setRenewSubscription] = useState(false);

  const handleConfirmSubscription = async () => {
    if (planId && planBillingCycle) {
      try {
        const currentUser = await getCurrentUser();
        if (!currentUser || !currentUser.user || !currentUser.user.id) {
          throw new Error('No se pudo obtener el ID del usuario actual.');
        }

        const endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1); // Asumimos un año de suscripción para el plan básico

        const subscriptionData = {
          plan_id: planId,
          billing_type: planBillingCycle as 'monthly' | 'yearly' | 'weekly',
          payment_method: 'free_tier',
          user: currentUser.user.id,
          end_date: endDate.toISOString().split('T')[0],
        };

        await subscribeToPlan(subscriptionData);
        onClose();
      } catch (error) {
        console.error('Error al suscribirse al plan:', error);
        alert('Error al suscribirse al plan. Por favor, inténtalo de nuevo.');
      }
    }
  };

  const handleMercadoPagoPayment = async () => {
    if (planId) {
      try {
        if (renewSubscription) {
          const response = await createRecurringPayment(planId);
          console.log('response', response);
          window.location.href = response.init_point;
        } else {
          const response = await createOneTimePayment(planId);
          console.log('response', response);
          window.location.href = response.init_point;
        }
      } catch (error) {
        console.error('Error al iniciar el pago con Mercado Pago:', error);
        alert('Error al iniciar el pago con Mercado Pago. Por favor, inténtalo de nuevo.');
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="subscription-modal-title"
      aria-describedby="subscription-modal-description"
    >
      <Box sx={style}>
        <Typography id="subscription-modal-title" variant="h6" component="h2" gutterBottom>
          {planName === 'Básico' || planName === 'Freemium' || planName === 'Freemium IA' ? 'Confirmar Suscripción' : 'Selecciona tu Método de Pago'}
        </Typography>
        {planName === 'Básico' || planName === 'Freemium' || planName === 'Freemium IA' ? (
          <Box>
            <Typography id="subscription-modal-description" sx={{ mt: 2 }}>
              ¿Estás seguro de que quieres suscribirte al plan {planName}?
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmSubscription}
              sx={{ mt: 3, mr: 1 }}
            >
              Confirmar Suscripción
            </Button>
            <Button variant="outlined" onClick={onClose} sx={{ mt: 3 }}>
              Cancelar
            </Button>
          </Box>
        ) : (
          <Box sx={{ mt: 2 }}>
            <Typography id="subscription-modal-description" sx={{ mb: 2 }}>
              Para el plan <strong>{planName}</strong>, por favor completa el pago con Mercado Pago.
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={renewSubscription}
                  onChange={(event) => setRenewSubscription(event.target.checked)}
                  name="renewSubscription"
                  color="primary"
                />
              }
              label="Renovar automáticamente"
            />
            {/* Placeholder para el logo de Mercado Pago */}
            <Card sx={{ maxWidth: 200, mx: 'auto', mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
                <img src={logomp} alt="Mercado Pago Logo" style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
              </Box>

            </Card>
            <Button variant="contained" color="primary" onClick={handleMercadoPagoPayment}>
              Pagar con Mercado Pago
            </Button>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default SubscriptionModal;
